/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EDirection {
  FORWARD = 'FORWARD',
  BACKWARD = 'BACKWARD',
  BOTH = 'BOTH'
}
